import React, {Component} from 'react';



export default class ToolTip extends Component {
  render() {
    const {header, body, footer, x_pos, y_pos, theme_colors } = this.props;

    // console.log(header);
    // console.log(body);
    // console.log(footer);

    var longest = (body.length === 0 )? 'longest': body.reduce(function (a, b) { return a.length > b.length ? a : b; });
    const const_width = 7 * longest.length;

    const header_h = 10;
    const body_item_h = 10;
    const footer_h = 10;

    const cv_width = 15;
    const cv_height = 15;

    let content_width = const_width + cv_width;
    let content_height = 0 + (cv_height * 1);
    if (header){content_height += header_h;}
    if (footer){content_height += footer_h;}
    if (body){content_height += (body_item_h * body.length);}

    const tt_width = content_width;
    const tt_height = content_height;
    const dist_to_center = tt_width / 2;

    // https://www.w3schools.com/graphics/svg_path.asp
    const path = `M 0 0 
      l -${cv_width} -${cv_height} 
      h ${-dist_to_center} 
      v ${-(tt_height)} 
      h ${tt_width + cv_width} 
      v ${tt_height} 
      h ${-(tt_width - dist_to_center)} 
      Z`;

    const text_y = -(tt_height + (cv_height / 2));
    const text_x_left = -(dist_to_center + (cv_width / 2));

    return (
      <g className="tt" style={{zIndex: 9999}} transform={`translate(${x_pos}, ${y_pos})`}>
        <path d={path} fill={theme_colors.tt.bg} />
        <text y={text_y} fontWeight="normal" fontSize="7px" fill={theme_colors.tt.text}>
          <tspan x={text_x_left} dy="5" fill={theme_colors.tt.muted}>{header}</tspan>
        </text>
        {body.map(function(body_item, idx){
          return(
            <text key={idx} y={text_y + 3 + (body_item_h * idx)} fontWeight="normal" fontSize="11px" fill={theme_colors.tt.text} >
              <tspan x={text_x_left} dy={body_item_h+5} >{body_item}</tspan>
            </text>
          )
        })}
        <text y={text_y+((body_item_h+0) * body.length)} fontWeight="normal" fontSize="7px" fill="#999999">
          <tspan x={text_x_left} dy={"20"} >{footer}</tspan>
        </text>
      </g>
    );
  }
}
